import { useCallback, useEffect } from 'react';
export var useKeyPress = function (targetKeys, callback, keyEvent) {
    if (keyEvent === void 0) { keyEvent = 'keydown'; }
    var pressHandler = useCallback(function (event) {
        var keys = Array.isArray(targetKeys) ? targetKeys : [targetKeys];
        if (keys.indexOf(event.key) >= 0) {
            callback(event);
        }
    }, [targetKeys, callback]);
    useEffect(function () {
        window.addEventListener(keyEvent, pressHandler);
        return function () { return window.removeEventListener(keyEvent, pressHandler); };
    }, [pressHandler, keyEvent]);
};
//# sourceMappingURL=useKeyPress.js.map